"use client";

import * as Sentry from "@sentry/nextjs";
import Error from "next/error";
import { useEffect } from "react";

type GlobalErrorProps = {
  error: any;
}

export default function GlobalError(props:Readonly<GlobalErrorProps>) {
  const { error } = props;
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <Error statusCode={error} />
      </body>
    </html>
  );
}
